import {
  ACCESSIBILITY_ARGS,
  ACTION_ARGS,
  ALL_LAYOUT_ARGS,
  ANCHORED_ARGS,
  BUTTON_ARGS,
  COMPONENT_STATE_ARGS,
  CONTAINER_ARGS,
  CONTENT_ARGS,
  FLEX_ARGS,
  GRID_ARGS,
  INPUT_FIELD_ARGS,
  INPUT_FORM_ARGS,
  INPUT_GROUP_ARGS,
  INPUT_MENU_ARGS,
  INPUT_SELECT_ALL_ARGS,
  INPUT_TRIGGER_ARGS,
  LINK_ARGS,
  MENU_ARGS,
  MENU_PLACEMENT_ARG,
  MODAL_ARGS,
  POSITIONING_ARGS,
  SIZING_ARGS,
  TOOLTIP_ARGS,
} from './metadata/shared-arguments';

import {
  Arg,
  ArgTypes,
  Metadata,
  pick,
  pickAll,
  warnDeprecatedArguments,
  warnOverriddenArguments,
} from './metadata/builder';

// Re-export all shared arguments
export {
  ACCESSIBILITY_ARGS,
  ACTION_ARGS,
  ALL_LAYOUT_ARGS,
  ANCHORED_ARGS,
  BUTTON_ARGS,
  COMPONENT_STATE_ARGS,
  CONTAINER_ARGS,
  CONTENT_ARGS,
  FLEX_ARGS,
  GRID_ARGS,
  INPUT_FIELD_ARGS,
  INPUT_FORM_ARGS,
  INPUT_GROUP_ARGS,
  INPUT_MENU_ARGS,
  INPUT_SELECT_ALL_ARGS,
  INPUT_TRIGGER_ARGS,
  LINK_ARGS,
  MENU_ARGS,
  MENU_PLACEMENT_ARG,
  MODAL_ARGS,
  POSITIONING_ARGS,
  SIZING_ARGS,
  TOOLTIP_ARGS,
};

// Re-export Metadata builder classes and helpers
export { Arg, ArgTypes, Metadata, pick, pickAll, warnDeprecatedArguments, warnOverriddenArguments };

export default {
  ACCESSIBILITY_ARGS,
  ACTION_ARGS,
  ALL_LAYOUT_ARGS,
  ANCHORED_ARGS,
  BUTTON_ARGS,
  COMPONENT_STATE_ARGS,
  CONTAINER_ARGS,
  CONTENT_ARGS,
  FLEX_ARGS,
  GRID_ARGS,
  INPUT_FIELD_ARGS,
  INPUT_FORM_ARGS,
  INPUT_GROUP_ARGS,
  INPUT_MENU_ARGS,
  INPUT_SELECT_ALL_ARGS,
  INPUT_TRIGGER_ARGS,
  LINK_ARGS,
  MENU_ARGS,
  MENU_PLACEMENT_ARG,
  MODAL_ARGS,
  POSITIONING_ARGS,
  SIZING_ARGS,
  TOOLTIP_ARGS,
  Arg,
  ArgTypes,
  Metadata,
  pick,
  pickAll,
};
